import { render } from "./EditPasswordPage.vue?vue&type=template&id=b60960e2&ts=true"
import script from "./EditPasswordPage.vue?vue&type=script&lang=ts"
export * from "./EditPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__